import { API } from "aws-amplify";
import { useEffect, useContext, useState } from "react";
import { ApiName, READ_ISSUES, UPDATE_ISSUES, RedminePath } from "../actions";
import AppContext from "../contexts/AppContext";

export const useTasks = () => {
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState({});
  const [redmineUrl, setRedmineUrl] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [assignedId, setAssignedId] = useState("");
  const [errors, setErrors] = useState({});
  const [init, setInit] = useState(false);

  const limit = 25;
  const generateQuery = (page = 1, project_id = undefined, status_id = "*") => {
    let query = `?limit=${limit}`; // ページネーションで表示するチケットの件数。Redmineのデフォルトが25件のため25とする
    query += project_id ? `&project_id=${project_id}` : "";
    query += `&page=${page}`;
    query += `&assigned_to_id=${assignedId}`;
    query += `&status_id=${status_id}`;
    return { query };
  };

  useEffect(() => {
    setInit(false);
    if (state.current.user) {
      setRedmineUrl(state.current.redmineurl);
      setApiKey(state.current.apikey);
      setAssignedId(state.current.user.id);
      setInit(true);
    }
  }, [state.current]);

  useEffect(() => {
    setTasks(state.issues);
  }, [state.issues]);

  const readTasks = (page = 1, project_id = undefined, status_id = "*") => {
    const conditions = generateQuery(page, project_id, status_id);
    try {
      setErrors({});
      if (loading !== true) setLoading(true);

      // if (apiKey !== "" && redmineUrl !== "") {
      if (apiKey) {
        const myInit = {
          headers: { "Content-type": "application/json", "X-Api-Key": apiKey },
          queryStringParameters: {
            path: "issues.json" + conditions.query,
            url: redmineUrl,
          },
        };
        API.get(ApiName, RedminePath, myInit)
          .then((response) => {
            dispatch({ type: READ_ISSUES, response });
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            setErrors({ api: err });
          });
        return "success";
      }
    } catch (err) {
      console.log("error");
      setErrors({ function: err });
    }
  };
  const updateTask = async (id, issue_status, status_name) => {
    try {
      setErrors({});
      // if (loading !== true) setLoading(true);
      if (apiKey) {
        const body = {
          issue: {
            status: { id: issue_status },
            status_id: issue_status,
          },
        };
        const myInit = {
          body,
          headers: { "X-Api-Key": apiKey },
          queryStringParameters: {
            path: "issues/" + id + ".json",
            url: redmineUrl,
          },
        };
        const response = await API.put(ApiName, RedminePath, myInit);
        if (response.success.statuscode === 204) {
          const res = { id, issue_status, status_name };
          dispatch({ type: UPDATE_ISSUES, res });
        }
        // setLoading(false);
      }
    } catch (err) {
      console.log("error");
      setErrors({ function: err });
    }
  };

  return {
    loading,
    setLoading,
    readTasks,
    updateTask,
    tasks,
    errors,
    init,
  };
};
